import { b as bootstrapLazy } from './index-90f57bcb.js';
import { a as patchEsm } from './patch-cf9bdeea.js';
var defineCustomElements = function defineCustomElements(win, options) {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(function () {
    return bootstrapLazy([["deckgo-highlight-code", [[1, "deckgo-highlight-code", {
      "src": [1],
      "anchor": [1],
      "anchorZoom": [1, "anchor-zoom"],
      "hideAnchor": [4, "hide-anchor"],
      "language": [513],
      "highlightLines": [513, "highlight-lines"],
      "lineNumbers": [516, "line-numbers"],
      "terminal": [513],
      "editable": [4],
      "theme": [513],
      "editing": [32],
      "themeStyle": [32],
      "languagesToLoad": [32],
      "loaded": [32],
      "load": [64],
      "findNextAnchor": [64],
      "zoomCode": [64]
    }, [[4, "prismLanguageLoaded", "languageLoaded"]]]]]], options);
  });
};
export { defineCustomElements };